import React from 'react';

function Title(props) {

    return(
        <div>
            <h1 className="gif_title">{props.title}</h1>   
        </div>
    )
} 

export default Title